/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SystemAnnouncementCreateCommandV1 } from '../models/system-announcement-create-command-v-1';
import { SystemAnnouncementV1 } from '../models/system-announcement-v-1';


/**
 * System announcements management (ops/erp only)
 */
@Injectable({
  providedIn: 'root',
})
export class SystemAnnouncementsV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listSystemAnnouncementsV1
   */
  static readonly ListSystemAnnouncementsV1Path = '/v1/notifications/announcements';

  /**
   * List all system announcements.
   *
   * Returns all active system announcements for the current tenant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSystemAnnouncementsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSystemAnnouncementsV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SystemAnnouncementV1>> {

    const rb = new RequestBuilder(this.rootUrl, SystemAnnouncementsV1Service.ListSystemAnnouncementsV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SystemAnnouncementV1>;
      })
    );
  }

  /**
   * List all system announcements.
   *
   * Returns all active system announcements for the current tenant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSystemAnnouncementsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSystemAnnouncementsV1(params?: {
  },
  context?: HttpContext

): Observable<SystemAnnouncementV1> {

    return this.listSystemAnnouncementsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SystemAnnouncementV1>) => r.body as SystemAnnouncementV1)
    );
  }

  /**
   * Path part for operation createSystemAnnouncementV1
   */
  static readonly CreateSystemAnnouncementV1Path = '/v1/notifications/announcements';

  /**
   * Create and publish a system announcement.
   *
   * Creates a release or maintenance announcement and fans out a UserNotification to all matching users asynchronously. targetRoles restricts visibility (null = all roles). Requires ops or erp credentials.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSystemAnnouncementV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemAnnouncementV1$Response(params: {

    /**
     * Announcement details
     */
    body: SystemAnnouncementCreateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SystemAnnouncementV1>> {

    const rb = new RequestBuilder(this.rootUrl, SystemAnnouncementsV1Service.CreateSystemAnnouncementV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SystemAnnouncementV1>;
      })
    );
  }

  /**
   * Create and publish a system announcement.
   *
   * Creates a release or maintenance announcement and fans out a UserNotification to all matching users asynchronously. targetRoles restricts visibility (null = all roles). Requires ops or erp credentials.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSystemAnnouncementV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemAnnouncementV1(params: {

    /**
     * Announcement details
     */
    body: SystemAnnouncementCreateCommandV1
  },
  context?: HttpContext

): Observable<SystemAnnouncementV1> {

    return this.createSystemAnnouncementV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SystemAnnouncementV1>) => r.body as SystemAnnouncementV1)
    );
  }

  /**
   * Path part for operation getActiveMaintenanceV1
   */
  static readonly GetActiveMaintenanceV1Path = '/v1/notifications/announcements/maintenance/active';

  /**
   * Get currently active maintenance windows.
   *
   * Returns maintenance announcements whose window is currently active (startAt <= now <= endAt). Used by the frontend to display the in-app banner during a maintenance window.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveMaintenanceV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveMaintenanceV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SystemAnnouncementV1>> {

    const rb = new RequestBuilder(this.rootUrl, SystemAnnouncementsV1Service.GetActiveMaintenanceV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SystemAnnouncementV1>;
      })
    );
  }

  /**
   * Get currently active maintenance windows.
   *
   * Returns maintenance announcements whose window is currently active (startAt <= now <= endAt). Used by the frontend to display the in-app banner during a maintenance window.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveMaintenanceV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveMaintenanceV1(params?: {
  },
  context?: HttpContext

): Observable<SystemAnnouncementV1> {

    return this.getActiveMaintenanceV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SystemAnnouncementV1>) => r.body as SystemAnnouncementV1)
    );
  }

}
